import base from "./base.service";

const requestotp = payload => base.post('/auth/login', payload);

const requestotpAgain = payload => base.post('/auth/requestOtp', payload);

const verifyotp = payload => base.post('/auth/verifyOtp', payload);

const signup = payload => base.post('/auth/signup', payload);

const logout = () => base.get('/auth/logOut');
const switchProfile =()=>base.get('/auth/switchProfile');

export const authService = {
    requestotp,
    verifyotp,
    signup,
    logout,
    switchProfile,
    requestotpAgain,
};